import { ROW_COLUMNS, RowColumn } from './labels';

const keyFor = (sheetId: string) => `nyhetslanseringar.yearbook.columns.${sheetId}`;

export function hiddenColumns(sheetId: string, sheetColumns: string[]): RowColumn[] {
  try {
    const stored = localStorage.getItem(keyFor(sheetId));
    if (stored) {
      const parsed = JSON.parse(stored) as unknown;
      if (Array.isArray(parsed)) return parsed.filter((column): column is RowColumn => ROW_COLUMNS.includes(column as RowColumn));
    }
  } catch {
    // A broken local value falls back to the sheet's own columns.
  }
  return ROW_COLUMNS.filter((column) => column !== 'categoryContact' && column !== 'ean' && !sheetColumns.includes(column));
}

export function saveHiddenColumns(sheetId: string, hidden: RowColumn[]): void {
  localStorage.setItem(keyFor(sheetId), JSON.stringify(hidden));
}
